import React, { useState } from "react";
import plusGrayIcon from "../assets/plusGrayIcon.png";
import useSupplierStore from "../store/supplierStore/index.js";
import api from "../services/api.js";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import DeleteButton from "./DeleteButton.jsx";

const AddSuppliers = ({
  suppliers,
  addSupplier,
  updateSupplier,
  removeSupplier,
}) => {
  //const { products, getProducts } = useProductStore();

  const [successMessage, setSuccessMessage] = useState("");
  const [editingSupplierId, setIsEditingSupplierId] = useState(null);
  const [editedSupplier, setEditedSupplier] = useState({});
  const [editErrorMessage, setEditErrorMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const supplierSchema = z.object({
    supplier_name: z.string().min(1, "O nome é obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: zodResolver(supplierSchema) });

  const onFormSubmit = async (values) => {
    try {
      const response = await api.post(`/suppliers/create-supplier`, values);
      addSupplier(response.data);
      reset();
    } catch (error) {
      console.error("Erro ao criar fornecedor: ", error);
    }
  };

  const handleEditClick = (supplier) => {
    setIsEditingSupplierId(supplier.id);
    setEditedSupplier(supplier);
    setEditErrorMessage("");
  };

  const handleSaveClick = async (id) => {
    try {
      const { createdAt, updatedAt, ...supplierData } = editedSupplier;

      const validation = supplierSchema.safeParse(supplierData);

      if (!validation.success) {
        setEditErrorMessage(
          `Por favor, revise o nome do Fornecedor e tente novamente`
        );
        return;
      }

      await api.put(`/suppliers/${id}`, supplierData);

      updateSupplier(id, supplierData);
      setEditErrorMessage("");
      setIsEditingSupplierId(null);
    } catch (error) {
      console.error("Erro inesperado:", error);
      setEditErrorMessage("Ocorreu um erro ao salvar. Tente novamente.");
    }
  };

  const handleDeleteSupplier = async (id) => {
    try {
      await api.delete(`/suppliers/${id}`);
      removeSupplier(id);
    } catch (error) {
      console.error("erro ao excluir fornecedor: ", error);
      setErrorMessage(
        "Erro ao excluir fornecedor. Verifique se algum pedido utiliza esse fornecedor"
      );
      return "Erro ao excluir fornecedor. Verifique se algum pedido utiliza esse fornecedor";
    }
  };

  const handleInputChange = (e, field) => {
    setEditedSupplier({ ...editedSupplier, [field]: e.target.value });
  };

  return (
    <div className="bg-[#F2F2F2] rounded-md px-2 pb-4 pt-8 mt-4 ml-2 h-90  text-boldGray opacity-90">
      <table className="w-full border-gray-300">
        <thead>
          <tr className="h-16 flex">
            <th className="flex-1 text-center">FORNECEDORES</th>
          </tr>
        </thead>
        <tbody>
          <div className="overflow-y-auto custom-scrollbar h-[200px]">
            <div className="mr-4">
              {suppliers.map((supplier) => {
                return (
                  <tr
                    className="h-20  flex  rounded-md bg-gray-200 mt-4 relative items-center justify-center"
                    key={supplier.id}
                  >
                    {editingSupplierId === supplier.id ? (
                      <>
                        {editErrorMessage && (
                          <div className="absolute -top-4">
                            <p className="text-red-500  text-sm">
                              {editErrorMessage}
                            </p>
                          </div>
                        )}
                        <td className="flex-1 text-center">
                          <input
                            value={editedSupplier.supplier_name || ""}
                            onChange={(e) =>
                              handleInputChange(e, "supplier_name")
                            }
                            className="w-full h-full text-center border border-gray-300 rounded p-2 box-border"
                          />
                        </td>
                        <div className="ml-2 flex gap-x-2">
                          <button
                            onClick={() => handleSaveClick(supplier.id)}
                            className="bg-green-500 text-white px-2 py-1 rounded"
                          >
                            Salvar
                          </button>
                          <button
                            className="text-2xl"
                            onClick={() => setIsEditingSupplierId(null)}
                          >
                            <IoMdClose />
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <td className="flex items-center w-[10rem] ">
                          <div
                            className="flex-grow text-center"
                            style={{ width: "80%" }}
                          >
                            {supplier.supplier_name}
                          </div>
                          <div
                            className="flex flex-col gap-y-4 items-end ml-6"
                            style={{ width: "20%" }}
                          >
                            <button onClick={() => handleEditClick(supplier)}>
                              <FaEdit />
                            </button>
                            <DeleteButton
                              onConfirm={() =>
                                handleDeleteSupplier(supplier.id)
                              }
                              errorMessage={errorMessage}
                              setErrorMessage={setErrorMessage}
                            />
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
            </div>
          </div>
        </tbody>
      </table>

      <form onSubmit={handleSubmit(onFormSubmit)} className="w-full flex mt-4">
        <input
          placeholder="Fornecedor"
          className="w-full py-2 px-4 text-center"
          {...register("supplier_name")}
        />

        <button
          className="w-1/4 py-2 px-4 bg-orange-500 text-white hover:bg-orange-600"
          type="submit"
        >
          +
        </button>
      </form>
      {Object.keys(errors).length > 0 && (
        <p className="text-red-500 mt-4">
          Por favor, verifique os dados e tente novamente.
        </p>
      )}

      {/* {sucessMessage && <p className="mt-2">{sucessMessage}</p>} */}
    </div>
  );
};

export default AddSuppliers;
